export default __webpack_public_path__ + "static/media/coffin.a5716f0f.png";